import React from "react";
//#region components
import { ActionLinkButton, Icon } from "components/common";
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const ContactSupportLink: React.FC = () => {
  return (
    <ActionLinkButton
      href={UrlHelper.formatPath(`/Support/CreateCase`)}
      endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} />}
      className={cssExports.supportLinkText}
    >
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.ContactUs)}
    </ActionLinkButton>
  );
};

export default ContactSupportLink;
